import {
  RESET
  SET_GRAPH
  SET_NAME
  SET_STEPS
  SET_FIELD_DATA
  SET_IS_HIDDEN
  SET_TYPE_NODE
  SET_LABEL
  SET_CONFIRMATION_MESSAGE
} from './actionTypes'
import { defaultState } from './index'

export reducer = (state, { type, payload }) ->
  try
    switch (type)
      when SET_GRAPH
        { state..., graph: payload.data }
      when SET_NAME
        { state..., name: payload.data }
      when SET_STEPS
        { state..., steps: payload.data }
      when SET_FIELD_DATA
        { state..., fieldData: payload.data }
      when SET_IS_HIDDEN
        { state..., isHidden: payload.data }
      when SET_TYPE_NODE
        { state..., typeNode: payload.data }
      when SET_LABEL
        { state..., label: payload.data }
      when SET_CONFIRMATION_MESSAGE
        { state..., confirmationMessage: payload.data }
      when RESET
        defaultState()
      else
        throw new Error("CreateMacroData reducer recieved an invalid action type (#{ type }).")
  catch e
    console.error(e)


